<template>
  <div class="page">
		<PageHeader>
			Парсинг Валют
		</PageHeader>

		<div class="content">
			<h2>{{ form._id ? 'Редактировать' : 'Добавить' }} парсер</h2>
			<form @submit.prevent="SubmitParse()">
				<div class="item">
					<label>Статус:</label>
					<input type="checkbox" v-model="form.status">
				</div>
				<div class="item">
					<label>Валюта:</label>
					<select v-model="form.valuteId" required>
						<option default disable value="">Не выбрано</option>
						<option :value="valute._id" v-for="valute in valutes">{{ valute.title }}</option>
					</select>
				</div>
				<div class="item">
					<label>Ссылка API:</label>
					<input type="text" v-model="form.link" placeholder="https://funnysite.com/api/public...">
				</div>
				<div class="item">
					<label>Путь:</label>
					<input type="text" v-model="form.path" placeholder="result.item.course">
				</div>

				<h3>Умножить курс на этот:</h3>
				<div class="item">
					<label>Ссылка API (множитель):</label>
					<input type="text" v-model="form.multiplyBy.link" placeholder="https://funnysite.com/api/public...">
				</div>
				<div class="item">
					<label>Путь (множитель):</label>
					<input type="text" v-model="form.multiplyBy.path" placeholder="result.item.course">
				</div>
				<!-- <div class="item">
					<label>Заддержка:</label>
					<input type="number" v-model="form.delay">
				</div> -->
				<button type="submit" name="button">{{ form._id ? 'Сохранить' : 'Добавить' }}</button>
			</form>
			<br><hr /><br>
			<div class="block" v-for="parse in parses" style="padding: 5px" v-if="parses">
				{{ getValuteInfo(parse.valuteId).title }} |
				Статус: {{ parse.status ? 'Активно' : 'Неактивно' }}
				<p style="float: right; color: red;" @click.prevent="deleteParse(parse)">Удалить</p>
				<p style="float: right;color: orange;" @click="form = parse">Ред. |&nbsp;</p>
			</div>
		</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getParse, addParse, editParse, deleteParse } from '@/api'
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: 'ParseValutes',

	data: () => ({
		parses: false,
		form: {
			_id: false,
			status: false,
			valuteId: '',
			link: '',
			path: '',
			multiplyBy: {
				link: null,
				path: null
			}
			// delay: 30
		}
	}),

	mounted () {
		this.getValutes()
		//
		this.getParse()
	},

	computed: {
		...mapState('valutes', ['valutes'])
	},

	methods: {
		...mapActions('valutes', ['getValutes']),

		getParse () {
			return getParse ()
				.then(response => {
					this.parses = response.data.result
				})
		},

		SubmitParse () {
			if (this.form._id) {
				editParse (this.form._id, this.form)
					.then(() => alert('Успешно!'))
					.then(() => this.getParse())
			} else {
				addParse (this.form)
					.then(() => alert('Успешно!'))
					.then(() => this.getParse())
			}
		},

		deleteParse (item) {
			deleteParse (item._id)
				.then(() => alert('Успешно!'))
				.then(() => this.getParse())
		},

		getValuteInfo (id) {
			for (var i = 0; i < this.valutes.length; i++) {
				if (this.valutes[i]._id === id) {
					return this.valutes[i]
				}
			}
			//
			return null
		}
	}
}
</script>

<style scoped>
.item {
	display: block;
	margin: 5px 0;
}

.item > label,
.item > input,
.item > select {
	display: inline-block;
}

.item > textarea {
	display: block;
	margin-top: 5px;
	padding: 7px;
	font-family: verdana;
	width: 95%;
	min-height: 250px;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/ParseValutes/index.vue